import React from 'react';
import { Card, CardImg, CardImgOverlay, CardTitle, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Loading } from './LoadingComponent';

//All are implemented using functional commponents but different ways are used

//Function 1
function RenderMenuItem({ dish, imgsrc }) {
  return (
    <Card>
      <Link to={`/menu/${dish.id}`}>
      <CardImg width="100%" src={imgsrc} alt={dish.name} />
      <CardImgOverlay>
        <CardTitle>{dish.name}</CardTitle>
      </CardImgOverlay>
    </Link>
    </Card >
  );
}

//Function 2 : Also can be written as function Menu(props)
const Menu = (props) => {
  if(props.dishes.isLoading){
    return(
        <div className='container'>
            <div className='row'>
                <Loading/>
            </div>
        </div>
      )
  }
  else if(props.dishes.errMess){
      return(
          <div className='container'>
              <div className='row'>
                  <h4>{props.errMess}</h4>
              </div>
          </div>
      )
  }
  else{
    return (
      <div className="container">
        <div className='row'>
          <Breadcrumb>
          <BreadcrumbItem><Link to='/home'>Home</Link></BreadcrumbItem>
          <BreadcrumbItem active>Menu</BreadcrumbItem>
          </Breadcrumb>
          <div className='col-12'>
            <h3>Menu</h3>
            <hr/>
          </div>
        </div>
        <div className="row">
          <div key={props.dishes.dishes[0].id} className="col-12 col-md-5 m-1">
            <RenderMenuItem dish={props.dishes.dishes[0]} imgsrc="assets/images/uthappizza.png" />
          </div>
          <div key={props.dishes.dishes[0].id} className="col-12 col-md-5 m-1">
            <RenderMenuItem dish={props.dishes.dishes[1]} imgsrc="assets/images/zucchipakoda.png" />
          </div>
          <div key={props.dishes.dishes[0].id} className="col-12 col-md-5 m-1">
            <RenderMenuItem dish={props.dishes.dishes[2]} imgsrc="assets/images/vadonut.png" />
          </div>
          <div key={props.dishes.dishes[0].id} className="col-12 col-md-5 m-1">
            <RenderMenuItem dish={props.dishes.dishes[3]} imgsrc="assets/images/elaicheesecake.png" />
          </div>
        </div>
      </div>
    );
  }
}

export default Menu;